import { render, staticRenderFns } from "./LaundryConfiguration.vue?vue&type=template&id=7f925ecd&scoped=true"
import script from "./LaundryConfiguration.vue?vue&type=script&lang=js"
export * from "./LaundryConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f925ecd",
  null
  
)

export default component.exports